module.exports = __webpack_public_path__ + "lp/img/check_blue.b81cfa4a.svg";